import { getTemplateCreationRecordByTemplateId } from '@/pages/api/scribeAPIV2';
import { useQuery } from '@tanstack/react-query';

export const GET_TEMPLATE_REVERT_PREVIEW = 'GET_TEMPLATE_REVERT_PREVIEW';

/**
 * Resolves the 1-based version number the card will revert to. Render-time
 * preview only — the actual revert still re-resolves on click in
 * useRevertTemplateEdit so a stale preview can't switch the user to the
 * wrong version.
 */
export const useTemplateRevertPreview = (templateId: string | undefined) => {
  return useQuery({
    queryKey: [GET_TEMPLATE_REVERT_PREVIEW, templateId],
    queryFn: async () => {
      if (!templateId) return { previousVersionNumber: null };

      const {
        data: {
          template_creation_record: record,
          version_controls: rawVersionControls,
        },
      } = await getTemplateCreationRecordByTemplateId(templateId);

      const versionControls = [...rawVersionControls].sort((a, b) =>
        a.created_at.localeCompare(b.created_at)
      );
      const fromVersionControlId =
        record.selected_version_control_id ?? versionControls.at(-1)?.id;
      const selectedIndex = versionControls.findIndex(
        (versionControl) => versionControl.id === fromVersionControlId
      );

      if (selectedIndex <= 0) return { previousVersionNumber: null };

      return { previousVersionNumber: selectedIndex };
    },
    enabled: !!templateId,
    staleTime: 5 * 60 * 1000,
  });
};
